import { useRPCQuery } from "eddev/hooks"

export function useCheckoutConfig() {
  return useRPCQuery("api.ticketing.checkoutConfig", undefined, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  })
}
